import webBiLogger from '@wix/web-bi-logger';
import * as eventBuilderFunc from '@wix/bi-logger-logo-builder/v2';
import { ClientPersistanceService } from './ClientPersistanceService';
import shortId from 'shortid';
const logger = webBiLogger.factory().logger();
export const BIZ_MGR_BI_CONTAINER = 'biz-mgr';
export const LOGO_BI_CONTAINER = 'logo-standalone';
export const PRINT_STANDALONE_BI_CONTAINER = 'prints-standalone';
export const BRAND_STANDALONE = 'brand_standalone';

let container = '';
let userEntry = '';
let sessionId = '';
let packageType;
let brandId;
const clientPersistanceService = new ClientPersistanceService('logo-universal');

export function setBiContainerName(containerName) {
  container = containerName;
  setUserEntry();
}

export function initSessionId(options = {}) {
  sessionId = shortId();
  const oneDayInSeconds = 60 * 60 * 24;
  clientPersistanceService.set('biSessionId', sessionId, { expiration: oneDayInSeconds });

  const { screenName } = options;
  biLog('logoBuilderSessionCreated', { logoSessionId: sessionId, screenName });
}

async function getSessionId() {
  if (!sessionId) {
    sessionId = await clientPersistanceService.get('biSessionId');
  }
  return sessionId;
}

function setUserEntry() {
  if (container === LOGO_BI_CONTAINER) {
    userEntry = 'standalone';
  } else if (container === BIZ_MGR_BI_CONTAINER) {
    userEntry = BIZ_MGR_BI_CONTAINER;
  } else if (container === PRINT_STANDALONE_BI_CONTAINER) {
    userEntry = PRINT_STANDALONE_BI_CONTAINER;
  } else if (container === BRAND_STANDALONE) {
    userEntry = BRAND_STANDALONE;
  }
}

export function setBrandId(id) {
  brandId = id;
}

export function setPackageType(type) {
  packageType = type;
}

export const biLog = async (funcName, params) => {
  const logoSessionId = await getSessionId();
  if (eventBuilderFunc[funcName] && typeof eventBuilderFunc[funcName] === 'function') {
    logger.report(eventBuilderFunc[funcName]({ ...params, container, userEntry, logoSessionId, brandGuid: brandId, packageType }));
  } else {
    console.error(`[biService.js:biLog] ${funcName} does not exists`);
  }
};

export const biLogSafe = callback => {
  if (callback && typeof callback === 'function') {
    try {
      callback(biLog, logger);
    } catch (error) {
      console.error(`[biService.js:biLogSafe] error`, error.message);
    }
  } else {
    console.error(`[biService.js:biLogSafe] callback is not a function`);
  }
};
